import { useMemo } from 'react';
import type { SurveyPage, SurveyQuestion } from '../fetchSurvey/types';
import type { SurveyAnswers } from '../submitSurvey/types';
import type { CustomFieldValueMap } from '../surveyLogic/types/customFieldValues';
import { computeEarnedProgress } from './utils/earnedProgress';

export interface UseSurveyProgressProps {
  pages?: SurveyPage[];
  values?: SurveyAnswers | null;
  allQuestions?: SurveyQuestion[];
  earnedQuestionIds?: ReadonlySet<string>;
  progressRevision?: number;
  customFieldValues?: CustomFieldValueMap;
}

/**
 * Tracks survey progress from earned credits on the active survey path.
 */
export function useSurveyProgress({
  pages = [],
  values,
  allQuestions = [],
  earnedQuestionIds,
  progressRevision = 0,
  customFieldValues = {},
}: UseSurveyProgressProps) {
  return useMemo(() => {
    void progressRevision;
    return computeEarnedProgress(
      pages,
      values ?? {},
      allQuestions,
      earnedQuestionIds ?? new Set(),
      customFieldValues
    );
  }, [pages, values, allQuestions, earnedQuestionIds, progressRevision, customFieldValues]);
}
